import React, { useState } from 'react';
import { Sidebar } from './Sidebar/Sidebar';
import { Topbar } from './Topbar/Topbar';
import { MobileDrawer } from './MobileDrawer/MobileDrawer';
import { MobileBottomNav } from './MobileBottomNav';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const handleMenuClick = () => {
    setMobileDrawerOpen((prev) => !prev);
  };

  return (
    <div className="relative flex h-screen bg-background overflow-hidden">
      {/* ---------- Desktop Sidebar (Overlayed) ---------- */}
      <div className="hidden lg:block fixed left-0 top-0 h-screen z-40">
        <Sidebar />
      </div>

      {/* ---------- Main Content ---------- */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-20 transition-all duration-300">
        {/* Topbar (normal, scrolls with content) */}
        <Topbar onMenuClick={handleMenuClick} />

        {/* Main scrollable area */}
        <main className="flex-1 overflow-auto pb-16 lg:pb-0 lg:px-6 transition-all duration-300">
          {children}
        </main>

        {/* Mobile Bottom Navigation */}
        <MobileBottomNav
          onMenuClick={handleMenuClick}
          isMenuOpen={mobileDrawerOpen}
        />
      </div>

      {/* ---------- Mobile Drawer ---------- */}
      <MobileDrawer
        open={mobileDrawerOpen}
        onOpenChange={setMobileDrawerOpen}
      />
    </div>
  );
};
